import Skeleton from "react-loading-skeleton";
import {
	Accordion,
	AccordionItem,
	AccordionTrigger,
} from "@/components/Accordion";
import { Button } from "@/components/catalyst/Button";

export function ReferralLinkDetailSkeleton() {
	return (
		<div className="space-y-8">
			<Accordion
				multiple
				defaultValue={["base-details", "finances"]}
				className="space-y-4"
			>
				<AccordionItem value="base-details">
					<AccordionTrigger disabled>Base Details</AccordionTrigger>
					<div className="p-4 space-y-4">
						<div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
							<div className="space-y-2">
								<Skeleton width={100} />
								<Skeleton height={38} className="rounded-md" />
							</div>
							<div className="space-y-2">
								<Skeleton width={100} />
								<Skeleton height={38} className="rounded-md" />
							</div>
						</div>
						<div className="space-y-2">
							<Skeleton width={100} />
							<Skeleton height={38} className="rounded-md" />
						</div>
					</div>
				</AccordionItem>

				<AccordionItem value="finances">
					<AccordionTrigger disabled>Finances</AccordionTrigger>
					<div className="p-4 space-y-4">
						<div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
							<div className="space-y-2">
								<Skeleton width={100} />
								<Skeleton height={38} className="rounded-md" />
							</div>
							<div className="space-y-2">
								<Skeleton width={100} />
								<Skeleton height={38} className="rounded-md" />
							</div>
						</div>
					</div>
				</AccordionItem>
			</Accordion>

			<div className="flex justify-end pt-4">
				<Button disabled className="opacity-50 cursor-not-allowed">
					Save Changes
				</Button>
			</div>
		</div>
	);
}
